import bgTl from './images/home/bg-tl.png'
import bgTr from './images/home/bg-tr.png'
import bgBl from './images/home/bg-bl.png'
import bgBr from './images/home/bg-br.png'
import bgB from './images/home/bg-b.png'

export const AssetImages = {
  bgTl,
  bgTr,
  bgBl,
  bgBr,
  bgB,
}
import React, { ReactSVGElement } from 'react'
import { ReactComponent as CoinIcon } from './coin.svg'
import { ReactComponent as LoaderIcon } from './loader.svg'
import { ReactComponent as FinishSvg } from './finish.svg'
import { ReactComponent as ExternalIcon } from './external.svg'
import { ReactComponent as FailSvg } from './fail.svg'
import { ReactComponent as HelpSvg } from './help.svg'
import { ReactComponent as RefreshSvg } from './refresh.svg'

const iconsSvgMap = {
  Refresh: RefreshSvg,
}
export const SvgIcon = ({ name, color, size = 15 }: IconProps & { name: keyof typeof iconsSvgMap }) => {
  const SvgComponent = iconsSvgMap[name]
  if (!SvgComponent) {
    console.warn(`Icon "${name}" does not exist.`)
    return null
  }
  return <SvgComponent width={size} height={size} color={color} />
}

interface IconProps extends React.SVGProps<ReactSVGElement> {
  size?: number
}
const FinishICON = ({ color = '#2EF989', size = 24 }: IconProps) => {
  return <FinishSvg width={size} height={size} color={color} />
}
const FailIcon = ({ color = '#FF3F62', size = 24 }: IconProps) => {
  return <FailSvg width={size} height={size} color={color} />
}
const HelpIcon = ({ color = 'rgba(255,255,255, 0.6)', size = 24 }: IconProps) => {
  return <HelpSvg width={size} height={size} color={color} />
}

export const AssetSvgs = {
  CoinIcon,
  LoaderIcon,
  FinishIcon: FinishICON,
  ExternalIcon,
  FailIcon,
  HelpIcon,
}
